module.exports = __webpack_public_path__ + "static/knockout-a2f38da010b71664e168674aedc63499.svg";